module.exports = {"benefits":"BENEFICIO","cat":"Cat","currency":"R$","date":"Data","description":"Descrição","entExt":"Ent/Sai","hour":"Hora","payable":"A pagar","parking":"ESTACIONAMENTO","place":"Estabelecimento","receive":"Receber","stay":"Perm","toll":"PEDAGIO","valuesIn":"Valores em","veloeServices":"MENSALIDADE"}


//////////////////
// WEBPACK FOOTER
// ./src/app/elements/InvoiceDetailsListHeaders/data.json
// module id = 2073
// module chunks = 0